/**
 * Data retrieved in MockedData and used to generate ActivityGraph
 */

export const userActivity = {
    "data": {
        "userId": 12,
        "sessions": [
            {
                "day": "2020-07-01",
                "kilogram": 80,
                "calories": 240
            },
            {
                "day": "2020-07-02",
                "kilogram": 80,
                "calories": 220
            },
            {
                "day": "2020-07-03",
                "kilogram": 81,
                "calories": 280
            },
            {
                "day": "2020-07-04",
                "kilogram": 81,
                "calories": 290
            },
            {
                "day": "2020-07-05",
                "kilogram": 80,
                "calories": 160
            },
            {
                "day": "2020-07-06",
                "kilogram": 78,
                "calories": 162
            },
            {
                "day": "2020-07-07",
                "kilogram": 76,
                "calories": 390
            }
        ]
    }
}